import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFound from "./config/tokenNotFound";

export const deleteBoard = async (
    board_id: number | string
): Promise<TApiResult> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;

  return await client()
    .board.delete({
        query: {
          board_id
      },
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "deleteBoard");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
